import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(theme => ({
  root: {
    color: colors.black,
    outline: `2px solid ${theme.palette.grey[300]}`,
    outlineOffset: -2,
    borderTop: "none",
    height: "fit-content",
    paddingBottom: 8,
  },
  tab: {
    textTransform: "none",
  },
  scroller: {
    "& .MuiTabs-flexContainer": {
      borderTop: `2px solid ${theme.palette.grey[300]}`,
      borderBottom: `2px solid ${theme.palette.grey[300]}`,
    },
  },
  indicator: {
    bottom: "unset",
    top: 0,
    height: "100%",
    border: `2px solid ${theme.palette.grey[300]}`,
    borderTopWidth: 4,
    borderTopColor: theme.palette.secondary.main,
    borderBottomColor: colors.white,
    backgroundColor: "transparent",
  },
  tabContents: {
    padding: 44,
  },
  tooltip: {
    backgroundColor: theme.palette.grey[100],
    color: colors.black,
  },
}));

export default useStyles;
